<template>
	<div class="grided-template">
		<menu-component></menu-component>
		<div id="restrictions-container">
			<default-header></default-header>
			<div id="panel-container">
				<collapsible-panel :panel="view.productGroupPlateRestrictionsPanel"
					:folded="view.productGroupPlateRestrictionsPanel.folded"
					@collapsed="(v) => !(view.productGroupPlateRestrictionsPanel.folded = v) && fetchProductGroupPlateRestrictionsData()"
					v-if="view.productGroupPlateRestrictionsPanel.isVisible"
					v-bind:class="{ 'collapsible-panel-fullscren': view.productGroupPlateRestrictionsPanel.fullscreen }">
					<div id="frequency-header" class="frequency-header">
						<div class="generic-select-wrapper">
							<v-select class="restrinctions-select-autocomplete"
								v-model="view.productGroupPlateRestrictionsPanel.selectedValidity"
								:options="view.productGroupPlateRestrictionsPanel.validityOptions" :clearable="false"
								:getOptionLabel="this.getFormattedValidity"
								@input="refreshProductGroupPlateRestrictionsData">
								<span slot="no-options">{{
									view.productGroupPlateRestrictionsPanel.noOptionsText }}
								</span>
							</v-select>
						</div>
						<button class="button restrinctions-grid-button"
							@click="showValidityPopUp('productGroupRestrictions', 'add')">
							{{ $t('add_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityEditorPopUp(view.productGroupPlateRestrictionsPanel.selectedValidity, 'productGroupRestrictions')">
							{{ $t('edit_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="callController('showDeleteValidityConfirmationDialog',
							['productGroupRestrictions', view.productGroupPlateRestrictionsPanel, $modal])">
							{{ $t('exclude_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showExportPopUp(view.productGroupPlateRestrictionsPanel.selectedValidity, 'productGroupRestrictions', 'UNITY')">
							{{ $t('export_term') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityPopUp('productGroupRestrictions', 'replicate')">
							{{ $t('replicate_validity') }} 
						</button>
					</div>
					<!-- <tabbed-container>
						<tab title="Frequências" tab-name="frequency"> -->
					<grid-component class="low-height-grid" style="margin-top: 5px;"
						:grid="view.productGroupPlateRestrictionsPanel.gridConfiguration"
						@update:isAddingNewRow="updateIsAddingNewRow(view.productGroupPlateRestrictionsPanel, $event)"
						@update:hasCheckedRows="(ev) => updateCheckedRows(view.productGroupPlateRestrictionsPanel, ev)"></grid-component>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="button restrinctions-grid-button"
								@click="addNewRowToProductGroupPlateRestrictionsPanel">
								<i class="fas fa-plus"></i> {{ $t('new') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.productGroupPlateRestrictionsPanel.hasCheckedRows &&
								!view.productGroupPlateRestrictionsPanel.isAddingNewRow"
								@click="deleteProductGroupPlateRestrictionsPanelRows(view.productGroupPlateRestrictionsPanel)">
								<i class="fas fa-trash"></i> {{ $t('delete') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.productGroupPlateRestrictionsPanel.hasCheckedRows &&
								!view.productGroupPlateRestrictionsPanel.isAddingNewRow"
								@click="showExportPopUp(view.productGroupPlateRestrictionsPanel.selectedValidity, 'productGroupRestrictions', 'VALIDITY')">
								<i class="fas fa-file-export"></i> {{ $t('export_term') }} 
							</button>
							<button class="button restrinctions-grid-button"
								v-show="view.productGroupPlateRestrictionsPanel.isAddingNewRow"
								@click="() => removeNewRow(view.productGroupPlateRestrictionsPanel)">
								<i class="fas fa-times"></i> {{ $t('cancel') }} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button"
								@click="exportToExcel(view.productGroupPlateRestrictionsPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{ $t('export') }} </span>
							</button>
							<button class="button gray-button"
								@click="invertValue(view.productGroupPlateRestrictionsPanel, 'fullscreen')">
								<span v-show="!view.productGroupPlateRestrictionsPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.productGroupPlateRestrictionsPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
					<!-- </tab>
					</tabbed-container> -->
				</collapsible-panel>

				<collapsible-panel :panel="view.weekdayUtilizationPanel" :folded="view.weekdayUtilizationPanel.folded"
					@collapsed="(v) => !(view.weekdayUtilizationPanel.folded = v) && fetchWeekdayUtilizationData()"
					v-if="view.weekdayUtilizationPanel.isVisible"
					v-bind:class="{ 'collapsible-panel-fullscren': view.weekdayUtilizationPanel.fullscreen }">
					<div id="frequency-header" class="frequency-header">
						<div class="generic-select-wrapper">
							<v-select class="restrinctions-select-autocomplete"
								v-model="view.weekdayUtilizationPanel.selectedValidity"
								:options="view.weekdayUtilizationPanel.validityOptions" :clearable="false"
								:getOptionLabel="this.getFormattedValidity" @input="refreshWeekdayUtilizationData">
								<span
									slot="no-options">{{ view.weekdayUtilizationPanel.noOptionsText }}
								</span>
								</v-select>
						</div>
						<button class="button restrinctions-grid-button"
							@click="showValidityPopUp('weekdayUtilization', 'add')">
							{{ $t('add_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityEditorPopUp(view.weekdayUtilizationPanel.selectedValidity, 'weekdayUtilization')">
							{{ $t('edit_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="callController('showDeleteValidityConfirmationDialog',
							['weekdayUtilization', view.weekdayUtilizationPanel, $modal])">
							{{ $t('exclude_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showExportPopUp(view.weekdayUtilizationPanel.selectedValidity, 'weekdayUtilization', 'UNITY')">
							{{ $t('export_term') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityPopUp('weekdayUtilization', 'replicate')">
							{{ $t('replicate_validity') }} 
						</button>
					</div>
					<!-- <tabbed-container>
						<tab title="Frequências" tab-name="frequency"> -->
					<grid-component class="low-height-grid" style="margin-top: 5px;"
						:grid="view.weekdayUtilizationPanel.gridConfiguration"
						@update:isAddingNewRow="updateIsAddingNewRow(view.weekdayUtilizationPanel, $event)"
						@update:hasCheckedRows="(ev) => updateCheckedRows(view.weekdayUtilizationPanel, ev)"></grid-component>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="button restrinctions-grid-button" @click="addNewRowToWeekdayUsagePanel">
								<i class="fas fa-plus"></i> {{ $t('new') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.weekdayUtilizationPanel.hasCheckedRows &&
								!view.weekdayUtilizationPanel.isAddingNewRow"
								@click="deleteWeekdayUsagePanelRows(view.weekdayUtilizationPanel)">
								<i class="fas fa-trash"></i> {{ $t('delete') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.weekdayUtilizationPanel.hasCheckedRows &&
								!view.weekdayUtilizationPanel.isAddingNewRow"
								@click="showExportPopUp(view.weekdayUtilizationPanel.selectedValidity, 'weekdayUtilization', 'VALIDITY')">
								<i class="fas fa-file-export"></i> {{ $t('export_term') }} 
							</button>
							<button class="button restrinctions-grid-button"
								v-show="view.weekdayUtilizationPanel.isAddingNewRow"
								@click="() => removeNewRow(view.weekdayUtilizationPanel)">
								<i class="fas fa-times"></i> {{ $t('cancel') }} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.weekdayUtilizationPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{ $t('export') }} </span>
							</button>
							<button class="button gray-button"
								@click="invertValue(view.weekdayUtilizationPanel, 'fullscreen')">
								<span v-show="!view.weekdayUtilizationPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.weekdayUtilizationPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
					<!-- </tab>
					</tabbed-container> -->
				</collapsible-panel>

				<!--
				<collapsible-panel :panel="view.plateGroupProductPanel" :folded="view.plateGroupProductPanel.folded" 
				@collapsed="(v) => !(view.plateGroupProductPanel.folded = v) && fetchPlateGroupProductFrequencyData()"
				v-if="view.plateGroupProductPanel.isVisible"
				v-bind:class="{'collapsible-panel-fullscren': view.plateGroupProductPanel.fullscreen}">
					<div id="frequency-header" class="frequency-header">
						<div class="generic-select-wrapper">
							<v-select
								class="restrinctions-select-autocomplete"
								v-model="view.plateGroupProductPanel.selectedValidity"
								:options="view.plateGroupProductPanel.validityOptions" 
								:clearable="false"
								:getOptionLabel="this.getFormattedValidity"
								@input="refreshGroupPlateProductFrequencyData"
							><span slot="no-options">{{view.plateGroupProductPanel.noOptionsText}}</span></v-select>
						</div>
						<button class="button restrinctions-grid-button" @click="showValidityPopUp('plateGroupProduct')"> Adicionar Vigência</button>
						<button class="button restrinctions-grid-button" 
						@click="showValidityEditorPopUp(view.plateGroupProductPanel.selectedValidity, 'plateGroupProduct')"> 
						Editar Vigência </button>
						<button class="button restrinctions-grid-button" 
						@click="callController('showDeleteValidityConfirmationDialog', 
						['plateGroupProduct', view.plateGroupProductPanel, $modal])">
							 Excluir Vigência</button>
					</div>
				<tabbed-container>
						<tab title="Frequências" tab-name="frequency">
							<grid-component
							class="low-height-grid"
							style="margin-top: 5px;"
							:grid="view.plateGroupProductPanel.gridConfiguration"
							@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupProductPanel, $event)"
							@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupProductPanel, ev)"
						></grid-component>
						<div class="button-container">
							<div class="button-container-align-left">
								<button class="button restrinctions-grid-button" @click="addNewRowToPlateGroupProductPanel">
										<i class="fas fa-plus"></i> Novo </button>
								<button class="button restrinctions-grid-button"
								v-show="view.plateGroupProductPanel.hasCheckedRows &&
								!view.plateGroupProductPanel.isAddingNewRow"  
								@click="deleteGroupProductPanelRows(view.plateGroupProductPanel)">
								<i class="fas fa-trash"></i> Excluir </button>
								<button class="button restrinctions-grid-button"
									v-show="view.plateGroupProductPanel.isAddingNewRow"
									@click="() => removeNewRow(view.plateGroupProductPanel)">
										<i class="fas fa-times"></i> Cancelar </button>
							</div>
							<div class="button-container-align-right">
								<button class="button gray-button" @click="exportToExcel(view.plateGroupProductPanel)">
									<i class="fas fa-file-excel"></i>
									<span> Exportar </span> 
								</button>
								<button class="button gray-button" 
								@click="invertValue(view.plateGroupProductPanel,'fullscreen')">
									<span v-show="!view.plateGroupProductPanel.fullscreen">
										<i class="fas fa-expand-arrows-alt"></i>
									</span>
									<span v-show="view.plateGroupProductPanel.fullscreen">
										<i class="fas fa-compress-arrows-alt"></i>
									</span>
								</button>
							</div>
						</div>
						</tab>
					</tabbed-container>
				</collapsible-panel> -->

				<collapsible-panel :panel="view.plateGroupPanel" :folded="view.plateGroupPanel.folded"
					@collapsed="(v) => !(view.plateGroupPanel.folded = v) && fetchPlateGroupFrequencyData()"
					v-if="view.plateGroupPanel.isVisible"
					v-bind:class="{ 'collapsible-panel-fullscren': view.plateGroupPanel.fullscreen }">
					<div id="frequency-header" class="frequency-header">
						<div class="generic-select-wrapper">
							<v-select class="restrinctions-select-autocomplete"
								v-model="view.plateGroupPanel.selectedValidity"
								:options="view.plateGroupPanel.validityOptions" :clearable="false"
								:getOptionLabel="this.getFormattedValidity"
								@input="refreshGroupPlateFrequencyData">
								<span slot="no-options">{{
									view.plateGroupPanel.noOptionsText }}
								</span>
							</v-select>
						</div>
						<button class="button restrinctions-grid-button" @click="showValidityPopUp('plateGroup', 'add')">
							{{ $t('add_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityEditorPopUp(view.plateGroupPanel.selectedValidity, 'plateGroup')">
							{{ $t('edit_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="callController('showDeleteValidityConfirmationDialog',
							['plateGroup', view.plateGroupPanel, $modal])">
							{{ $t('exclude_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showExportPopUp(view.plateGroupPanel.selectedValidity, 'plateGroup', 'UNITY')">
							{{ $t('export_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="showValidityPopUp('plateGroup', 'replicate')">
							{{ $t('replicate_validity') }} 
						</button>
					</div>
					<!-- <tabbed-container>
						<tab title="Frequências" tab-name="frequency"> -->
					<grid-component class="low-height-grid" style="margin-top: 5px;"
						:grid="view.plateGroupPanel.gridConfiguration"
						@update:isAddingNewRow="updateIsAddingNewRow(view.plateGroupPanel, $event)"
						@update:hasCheckedRows="(ev) => updateCheckedRows(view.plateGroupPanel, ev)"></grid-component>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="button restrinctions-grid-button" @click="addNewRowToPlateGroupPanel">
								<i class="fas fa-plus"></i> {{ $t('new') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.plateGroupPanel.hasCheckedRows &&
								!view.plateGroupPanel.isAddingNewRow" @click="deleteGroupPanelRows(view.plateGroupPanel)">
								<i class="fas fa-trash"></i> {{ $t('delete') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.plateGroupPanel.hasCheckedRows &&
								!view.plateGroupPanel.isAddingNewRow"
								@click="showExportPopUp(view.plateGroupPanel.selectedValidity, 'plateGroup', 'VALIDITY')">
								<i class="fas fa-file-export"></i> {{ $t('export_term') }} 
							</button>
							<button class="button restrinctions-grid-button"
								v-show="view.plateGroupPanel.isAddingNewRow"
								@click="() => removeNewRow(view.plateGroupPanel)">
								<i class="fas fa-times"></i> {{ $t('cancel') }} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.plateGroupPanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{ $t('export') }} </span>
							</button>
							<button class="button gray-button" @click="invertValue(view.plateGroupPanel, 'fullscreen')">
								<span v-show="!view.plateGroupPanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.plateGroupPanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
					<!-- </tab>
					</tabbed-container> -->
				</collapsible-panel>

				<collapsible-panel :panel="view.platePanel" :folded="view.platePanel.folded"
					@collapsed="(v) => !(view.platePanel.folded = v) && fetchPlateFrequencyData()"
					v-if="view.platePanel.isVisible"
					v-bind:class="{ 'collapsible-panel-fullscren': view.platePanel.fullscreen }">
					<div id="frequency-header" class="frequency-header">
						<div class="generic-select-wrapper">
							<v-select class="restrinctions-select-autocomplete"
								v-model="view.platePanel.selectedValidity" :options="view.platePanel.validityOptions"
								:clearable="false" :getOptionLabel="this.getFormattedValidity"
								@input="refreshPlateFrequencyData">
								<span slot="no-options">{{
									view.platePanel.noOptionsText }}
								</span>
							</v-select>
						</div>
						<button class="button restrinctions-grid-button" @click="showValidityPopUp('plate', 'add')">
							{{ $t('add_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showValidityEditorPopUp(view.platePanel.selectedValidity, 'plate')">
							{{ $t('edit_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="callController('showDeleteValidityConfirmationDialog',
							['plate', view.platePanel, $modal])">
							{{ $t('exclude_validity') }} 
						</button>
						<button class="button restrinctions-grid-button"
							@click="showExportPopUp(view.platePanel.selectedValidity, 'plate', 'UNITY')">
							{{ $t('export_term') }} 
						</button>
						<button class="button restrinctions-grid-button" @click="showValidityPopUp('plate', 'replicate')">
							{{ $t('replicate_validity') }} 
						</button>
					</div>
					<!-- <tabbed-container>
						<tab title="Frequências" tab-name="frequency"> -->
					<grid-component class="low-height-grid" style="margin-top: 5px;"
						:grid="view.platePanel.gridConfiguration"
						@update:isAddingNewRow="updateIsAddingNewRow(view.platePanel, $event)"
						@update:hasCheckedRows="(ev) => updateCheckedRows(view.platePanel, ev)"></grid-component>
					<div class="button-container">
						<div class="button-container-align-left">
							<button class="button restrinctions-grid-button" @click="addNewRowToPlatePanel">
								<i class="fas fa-plus"></i> {{ $t('new') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.platePanel.hasCheckedRows &&
								!view.platePanel.isAddingNewRow" @click="deletePlatePanelRows(view.platePanel)"> <i class="fas fa-trash"></i>
								{{ $t('delete') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.platePanel.hasCheckedRows &&
								!view.platePanel.isAddingNewRow"
								@click="showExportPopUp(view.platePanel.selectedValidity, 'plate', 'VALIDITY')">
								<i class="fas fa-file-export"></i> {{ $t('export_term') }} 
							</button>
							<button class="button restrinctions-grid-button" v-show="view.platePanel.isAddingNewRow"
								@click="() => removeNewRow(view.platePanel)">
								<i class="fas fa-times"></i> {{ $t('cancel') }} 
							</button>
						</div>
						<div class="button-container-align-right">
							<button class="button gray-button" @click="exportToExcel(view.platePanel)">
								<i class="fas fa-file-excel"></i>
								<span> {{ $t('export') }} </span>
							</button>
							<button class="button gray-button" @click="invertValue(view.platePanel, 'fullscreen')">
								<span v-show="!view.platePanel.fullscreen">
									<i class="fas fa-expand-arrows-alt"></i>
								</span>
								<span v-show="view.platePanel.fullscreen">
									<i class="fas fa-compress-arrows-alt"></i>
								</span>
							</button>
						</div>
					</div>
					<!-- </tab>
					</tabbed-container> -->
				</collapsible-panel>

				<collapsible-panel :panel="view.rulesToBeFlexibleInScenarioPostProcessing"
					@collapsed="(v) => !(view.rulesToBeFlexibleInScenarioPostProcessing.folded = v)"
					v-if="view.rulesToBeFlexibleInScenarioPostProcessing.isVisible"
					:folded="view.rulesToBeFlexibleInScenarioPostProcessing.folded"
					v-bind:class="{ 'collapsible-panel-fullscren': view.rulesToBeFlexibleInScenarioPostProcessing.fullscreen }">
					<div class="grid-container">
						<grid-component class="low-height-grid" style="margin-top: 5px;"
							:grid="view.rulesToBeFlexibleInScenarioPostProcessing.gridConfiguration"
							:dragging_end="onRowDragEnd"></grid-component>
						<div class="button-container">
							<div class="button-container-align-right">
								<button class="button gray-button" @click="updRestoreFlexibleRules">
									<i class="fas fa-refresh"></i> {{ $t('restore') }} </button>
								<button class="button gray-button"
									@click="invertValue(view.rulesToBeFlexibleInScenarioPostProcessing, 'fullscreen')">
									<span v-show="!view.rulesToBeFlexibleInScenarioPostProcessing.fullscreen">
										<i class="fas fa-expand-arrows-alt"></i>
									</span>
									<span v-show="view.rulesToBeFlexibleInScenarioPostProcessing.fullscreen">
										<i class="fas fa-compress-arrows-alt"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
				</collapsible-panel>


			</div>
		</div>

		<modal name="validityModal" :height="'auto'">
			<div class="validity-form-root">
				<h3 class="title">
					{{ $modal.type === 'replicate' ? $t('replicate_term') : $t('new_term') }}
				</h3>
				<div class="date-fields-container">
					<div class="field">
						<label for="validity-initial-date"> {{ $t('initial_date') }} (*):</label>
						<input id="validity-initial-date" type="month"
							v-model="view.validityFormData.initialDate" />
					</div>
					<div class="field">
						<label for="validity-end-date">{{ $t('final_date') }}:</label>
						<input id="validity-end-date" type="month" v-model="view.validityFormData.endDate" />
					</div>
				</div>
				<div class="field autocomplete-field" v-show="view.validityFormData._caller !== 'weekdayUtilization'">
					<label for="validity-observation">{{ $t('note') }}: </label>
					<v-select id="validity-observation" class="restrinctions-select-autocomplete"
						v-model="view.validityFormData.selectedObservation" label="DSOBSFILI" value="CDDESCOBSFILIAL"
						:options="view.validityFormData.observationOptions" :clearable="false"></v-select>
				</div>
				<div class="field text-field">
					<label for="validity-description">{{ $t('description') }}:</label>
					<input id="validity-description" type="text" v-model="view.validityFormData.description" />
				</div>
				<button class="button save-validity-button" @click="saveValidity($modal.type)"> 
					{{ $t('save') }} 
				</button>
			</div>
		</modal>

		<modal name="editValidityModal" :height="180">
			<div class="validity-form-root">
				<h3 class="title"> {{ $t('edit_term') }} </h3>
				<div class="field text-field">
					<label for="edit-validity-description">{{ $t('description') }}:</label>
					<input id="edit-validity-description" type="text" v-model="view.validityFormData.description" />
				</div>
				<button class="button save-validity-button" @click="saveEditedValidity"> {{ $t('save') }} </button>
			</div>
		</modal>
		<!--<modal name="exportModal" :height="'auto'" :clickToClose="false">
			<div class="validity-form-root"> 
				<h3 class="title"> Exportar Vigência </h3>
				<div class="export-container">
					<div v-show="view.exportVigencia._button == 'UNITY'">
						<label for="export-unity">Unidade:</label>
						<div class="select-container">
							<v-select
								class="restrinctions-select-autocomplete"
								:multiple="true"
								:disabled="view.exportVigencia.checkedFilial"
								:options="view.exportVigencia.filial"
								:getOptionLabel="o => `${o.CDFILIAL} | ${o.NMFILIAL}`"
								:clearable="false" 
								v-model="view.exportVigencia.selectedFilial"
								@input="getServico"
							></v-select>
							<div class="input-container">
								<input 
									class="allCheck"
									type="checkbox"
									id="scales"
									name="scales"
									:checked="view.exportVigencia.checkedFilial"
									@click="allFiliClicked" 
								/>
								<span>Todos</span>
							</div>
						</div>
						
						<label for="export-service">Serviço:</label>
						<div class="select-container">
							<v-select
								class="restrinctions-select-autocomplete"
								:multiple="true"
								:disabled="view.exportVigencia.checkedService == true"
								:options="view.exportVigencia.services"
								:getOptionLabel="o => `${o.CDFILIAL} | ${o.CDSERVFILI} | ${o.NMSERVICO}`"
								:clearable="false" 
								v-model="view.exportVigencia.selectedService"
							></v-select>
							<div class="input-container">
								<input 
									class="allCheck"
									type="checkbox"
									id="scales"
									name="scales"
									:checked="view.exportVigencia.checkedService"
									@click="allServiceClicked" 
								/>
								<span>Todos</span>
							</div>
							
						</div>
					</div>
					<div v-show="view.exportVigencia._button == 'VALIDITY'">
						<label for="export-service">Vigência:</label>
						<v-select
							class="restrinctions-select-autocomplete"
							:options="view.exportVigencia.validity"
							:getOptionLabel="o => `${o.DTVIGENCIA} | ${o.DESCRICAO}`"
							:clearable="false" 
							v-model="view.exportVigencia.selectedValidity"
						></v-select>
					</div>
					
					<label for="export-typeExport">Tipo de Exportação:</label>
					<div class="mode-switch">
						<div @click="switchMode('ACRESCENTAR')" 
							class="mode-switch-option"
							:class="{active: view.exportVigencia.mode === 'ACRESCENTAR'}"> 
						Acrescentar </div>
						<div @click="switchMode('SOBREPOR')" 
							class="mode-switch-option"
							:class="{active: view.exportVigencia.mode === 'SOBREPOR'}"> 
						Sobrepor </div>
					</div>
				</div>
				<div>
					<button class="button ghost" @click="cancelExport"> <i class="fas fa-times"></i> Cancelar </button> 
					<button 
						class="button"
						style="position: relative; height: 33px; display: inline-block; vertical-align: middle; padding: 0;" 
						@click="saveExport"
					> 
						<span v-show="view.exportVigencia.showSpan"> Salvar </span> 
						<img v-show="!view.exportVigencia.showSpan" :src="view.exportVigencia.loadGif" style="height: 33px; margin: auto;"/>
					</button>
				</div>
			</div>
		</modal>-->
		<modal name="export-form-modal" :height="'auto'" :clickToClose="false">
			<export-form :modal="$modal" :name="$t('export_term')" :modalStyle="view.exportVigencia._button"
				:validity="view.exportVigencia._validity" :showLoad="view.exportVigencia._showLoad"
				@saveExport="saveExport" />
		</modal>
		<modal name="messageError" :height="'auto'" :clickToClose="false">
			<message-pop-up :modal="$modal" :title="view.exportVigencia._messageError.title"
				:message="view.exportVigencia._messageError.message" :nameModal="'messageError'" />
		</modal>
	</div>

</template>

<script>
import Menu from "@/components/src/MenuComponent";
import DefaultHeader from "@/components/src/DefaultHeaderComponent";
import CollapsiblePanel from "@/components/src/CollapsiblePanelComponent";
import TabbedContainer from "@/components/src/TabbedContainerComponent";
import Grid from "@/components/src/GridComponent";
import vSelect from "vue-select";
import Util from "@/application/libs/util"
import permissionManager from "@/application/libs/permissionManager"
import ExcelBuilder from '@/application/libs/excelBuilder'
import ExportForm from '@/components/src/ExportForm'
import MessagePopUp from '@/components/src/MessagePopUp'

// import {showConfirmationDialog} from '@/application/libs/ConfirmationDialog'

import eventModule from '@/application/libs/eventModule';
import RestrictionsController from "../controllers/RestrictionsController";
import { t } from 'i18next';

export default {
	name: "Restrictions",
	components: {
		"menu-component": Menu,
		"default-header": DefaultHeader,
		"collapsible-panel": CollapsiblePanel,
		"tabbed-container": TabbedContainer,
		"grid-component": Grid,
		"v-select": vSelect,
		"export-form": ExportForm,
		"message-pop-up": MessagePopUp
	},
	data() {
		return {
			view: {
				title: t('restrictions'),
				validityFormData: {
				},
				exportVigencia: {
					_showLoad: true,
					_messageError: {
						title: '',
						message: ''
					}
				},
				plateGroupPanel: {
					title: t('frequency_of_dish_groups'),
					// subtitle: "Grupos de Pratos",
					name: "plateGroupPanel",
					gridConfiguration: RestrictionsController.plateGroupGridConfig,
					validityOptions: [],
					selectedValidity: null,
					folded: true,
					noOptionsText: t('no_data_found'),
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_frequency_of_dish_groups') + `\n` + t('info_2_frequency_of_dish_groups')
				},
				platePanel: {
					title: t('dish_frequency'),
					// subtitle: "Prato",
					name: "platePanel",
					gridConfiguration: RestrictionsController.plateGridConfig,
					validityOptions: [],
					selectedValidity: null,
					folded: true,
					noOptionsText: t('no_data_found'),
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_dish_frequency') + `\n` + t('info_2_dish_frequency')
				},
				plateGroupProductPanel: {
					title: t('frequency_of_products_by_dish_groups'),
					// subtitle: "Produtos por Grupos de Pratos",
					name: "plateGroupProductPanel",
					gridConfiguration: RestrictionsController.plateGroupProductGridConfig,
					validityOptions: [],
					selectedValidity: null,
					folded: true,
					noOptionsText: t('no_data_found'),
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_frequency_of_products_by_dish_groups') + `\n` + t('info_2_frequency_of_products_by_dish_groups') + `\n` + t('info_3_frequency_of_products_by_dish_groups')
				},
				weekdayUtilizationPanel: {
					title: t('use_of_dish_group_in_the_week'),
					// subtitle: "Grupo de Prato na Semana",
					name: "weekdayUtilizationPanel",
					gridConfiguration: RestrictionsController.weekdayUtilizationGridConfig,
					validityOptions: [],
					selectedValidity: null,
					folded: true,
					noOptionsText: t('no_data_found'),
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_use_of_dish_group_in_the_week') + `\n` + t('info_2_use_of_dish_group_in_the_week')
				},
				productGroupPlateRestrictionsPanel: {
					title: t('product_restriction_by_dish_group'),
					// subtitle: "Produtos por Grupo de Prato",
					name: "productGroupPlateRestrictionsPanel",
					gridConfiguration: RestrictionsController.productGroupPlateRestrictionsGridConfig,
					validityOptions: [],
					selectedValidity: null,
					folded: false,
					noOptionsText: t('no_data_found'),
					hasCheckedRows: false,
					fullscreen: false,
					isAddingNewRow: false,
					isVisible: true,
					info: t('info_product_restriction_by_dish_group') + `\n` + t('info_2_use_of_dish_group_in_the_week')
				},
				rulesToBeFlexibleInScenarioPostProcessing: {
					title: t('rules_to_Be_Flexible_In_Scenario_PostProcessing'),
					name: "rulesToBeFlexibleInScenarioPostProcessing",
					gridConfiguration: RestrictionsController.rulesToBeFlexibleInScenarioPostProcessingGridConfig,
					fullscreen: false,
					selectedValidity: null,
					hasCheckedRows: false,
					isVisible: true,
					folded: true,
					gridApi: null,
					info: t('info_1_flexible_rule') + `\n` + t('info_2_flexible_rule')
				}
			}
		};
	},
	mounted() {
		document.title = `${this.view.title} - Cardápio Inteligente`;
		RestrictionsController.init({ validityFormData: this.view.validityFormData }); //init internal vars
		const { CDFILIAL, CDSERVFILI, TPCONTRATO, DTMESCARD } = Util.getFilterInSession();
		if (CDFILIAL && CDSERVFILI && TPCONTRATO && DTMESCARD) {
			this.getPlateGroupFrenquencyDataFromServer();
		}
	},
	created() {
		eventModule.$on('updateBoData', this.getPlateGroupFrenquencyDataFromServer);
		const permissions = permissionManager.getRestrictionsViewPermissions();
		Object.keys(permissions).forEach(panelName => this.view[panelName].isVisible = permissions[panelName]);
	},
	beforeDestroy() {
		eventModule.$off('updateBoData', this.getPlateGroupFrenquencyDataFromServer);
	},
	methods: {
		validityCallerConfig: function() {
			return {
				plateGroup: {
					panel: this.view.plateGroupPanel,
					from: 'VIGENCIAGRUPOPRATO',
				},
				plate: {
					panel: this.view.platePanel,
					from: 'VIGENCIAPRATO',
				},
				plateGroupProduct: {
					panel: this.view.plateGroupProductPanel,
					from: 'VIGENCIAGRUPOPRATOPRODUTO',
				},
				weekdayUtilization: {
					panel: this.view.weekdayUtilizationPanel,
					from: 'VIGENCIAUTILIZACAOPRATOSEMANA',
				},
				productGroupRestrictions: {
					panel: this.view.productGroupPlateRestrictionsPanel,
					from: 'VIGENCIAPRODUTOGRUPOPRATORESTRICACAO',
				},
			};
		},
		onRowDragEnd: function (e) {
			let start = e.node.data;
			let destiny = e.overNode.data;
			RestrictionsController.moveRulePosition(start, destiny);
		},
		getFormattedValidity: function (v) {
			return `${v.VIGENCIA} 
			${(v.VIGENCIAFIM && 'a') || ''} ${v.VIGENCIAFIM || ''} 
			${(v.DESCRICAO && '|') || ''} ${v.DESCRICAO || ''}`;
		},
		getPlateGroupFrenquencyDataFromServer: function () {
			!this.view.productGroupPlateRestrictionsPanel.folded && this.view.productGroupPlateRestrictionsPanel.isVisible && this.fetchProductGroupPlateRestrictionsData();
			!this.view.weekdayUtilizationPanel.folded && this.view.weekdayUtilizationPanel.isVisible && this.fetchWeekdayUtilizationData();
			!this.view.plateGroupPanel.folded && this.view.plateGroupPanel.isVisible && this.fetchPlateGroupFrequencyData();
			!this.view.platePanel.folded && this.view.platePanel.isVisible && this.fetchPlateFrequencyData();
			!this.view.plateGroupProductPanel.folded && this.view.plateGroupProductPanel.isVisible && this.fetchPlateGroupProductFrequencyData();
		},
		fetchPlateGroupFrequencyData: function () {
			RestrictionsController.fetchPlateGroupFrequencyData(this.view.plateGroupPanel)
		},
		fetchPlateFrequencyData: function () {
			RestrictionsController.fetchPlateFrequencyData(this.view.platePanel)
		},
		fetchPlateGroupProductFrequencyData: function () {
			RestrictionsController.fetchPlateGroupProductFrequencyData(this.view.plateGroupProductPanel)
		},
		fetchWeekdayUtilizationData: function () {
			RestrictionsController.fetchWeekdayUtilizationData(this.view.weekdayUtilizationPanel)
		},
		refreshGroupPlateFrequencyData: function (selectedValidity) {
			RestrictionsController.refreshPlateGroupFrequencyData(selectedValidity);
		},
		fetchProductGroupPlateRestrictionsData: function () {
			RestrictionsController.fetchProductGroupPlateRestrictionsData(this.view.productGroupPlateRestrictionsPanel)
		},
		refreshProductGroupPlateRestrictionsData: function (selectedValidity) {
			RestrictionsController.refreshProductGroupPlateRestrictionsData(selectedValidity);
		},
		refreshGroupPlateProductFrequencyData: function (selectedValidity) {
			RestrictionsController.refreshPlateGroupProductFrequencyData(selectedValidity);
		},
		refreshPlateFrequencyData: function (selectedValidity) {
			RestrictionsController.refreshPlateFrequencyData(selectedValidity);
		},
		refreshWeekdayUtilizationData: function (selectedValidity) {
			RestrictionsController.refreshWeekdayUtilizationData(selectedValidity);
		},
		addNewRowToPlateGroupPanel: function () {
			RestrictionsController.addNewRowToPlateGroupPanel();
		},
		addNewRowToPlateGroupProductPanel: function () {
			RestrictionsController.addNewRowToPlateGroupProductPanel();
		},
		addNewRowToPlatePanel: function () {
			RestrictionsController.addNewRowToPlatePanel();
		},
		addNewRowToWeekdayUsagePanel: function () {
			RestrictionsController.addNewRowToWeekdayUsagePanel();
		},
		addNewRowToProductGroupPlateRestrictionsPanel: function () {
			RestrictionsController.addNewRowToProductGroupPlateRestrictionsPanel();
		},
		saveValidity: function (validityType) {
			switch (validityType) {
				case 'add':
					this.addNewValidity()
					break;
				case 'replicate':
					this.replicateValidity()
					break;
			}
		},
		addNewValidity: function () {
			const { _caller } = this.view.validityFormData;

			const config = this.validityCallerConfig()[_caller];

			if (config) {
				RestrictionsController.saveValidity(
					this.view.validityFormData,
					config.panel,
					this.$modal,
					config.from
				);
			}
		},
		replicateValidity: function () {
			const { _caller } = this.view.validityFormData;

			const config = this.validityCallerConfig()[_caller];

			if (config) {
				RestrictionsController.replicateValidity(
					this.view.validityFormData,
					config.panel,
					this.$modal,
					config.from
				);
			}
		},
		deleteGroupPanelRows: function (plateGroupPanel) {
			RestrictionsController.deleteGroupPanelRows(plateGroupPanel);
		},
		deleteGroupProductPanelRows: function (plateGroupProductPanel) {
			RestrictionsController.deleteGroupProductPanelRows(plateGroupProductPanel);
		},
		deletePlatePanelRows: function (platePanel) {
			RestrictionsController.deletePlatePanelRows(platePanel);
		},
		deleteWeekdayUsagePanelRows: function (weekdayUtilizationPanel) {
			RestrictionsController.deleteWeekdayUsagePanelRows(weekdayUtilizationPanel);
		},
		deleteProductGroupPlateRestrictionsPanelRows: function (productGroupPlateRestrictionsPanel) {
			RestrictionsController.deleteProductGroupPlateRestrictionsPanelRows(productGroupPlateRestrictionsPanel);
		},

		showValidityPopUp: function (caller, type) {
			this.view.validityFormData._caller = caller;
			this.$modal.type = type
			this.$modal.show("validityModal", {});
			this.$forceUpdate();
		},
		showExportPopUp: function (selectedValidity, caller, clickedButton) {
			if (selectedValidity) {
				this.view.exportVigencia._caller = caller;
				this.view.exportVigencia._button = clickedButton;
				this.view.exportVigencia._showLoad = true;
				this.view.exportVigencia._validity = this.getValidity(caller);
				this.$modal.show("export-form-modal");
				this.$forceUpdate();
			} else {
				Util.showNotification({ title: t('unable_to_export_term'), text: t('no_term_has_been_selected') });
			}
		},
		showValidityEditorPopUp: function (selectedValidity, caller) {
			if (selectedValidity) {
				this.view.validityFormData.description = selectedValidity.DESCRICAO;
				this.view.validityFormData._caller = caller;
				RestrictionsController.showValidityEditorPopUp(this.$modal, caller);
				this.$forceUpdate();
			} else {
				Util.showNotification({ title: t('unable_to_edit_term'), text: t('no_term_has_been_selected') });
			}
		},
		saveEditedValidity: function () {
			if (this.view.validityFormData._caller === "plateGroup") {
				RestrictionsController.saveChangedPlateGroupValidity(this.view.validityFormData,
					this.view.plateGroupPanel, this.$modal);
			} else if (this.view.validityFormData._caller === "plate") {
				RestrictionsController.saveChangedPlateValidity(this.view.validityFormData,
					this.view.platePanel, this.$modal);
			} else if (this.view.validityFormData._caller === "plateGroupProduct") {
				RestrictionsController.saveChangedPlateGroupProductValidity(this.view.validityFormData,
					this.view.plateGroupProductPanel, this.$modal);
			} else if (this.view.validityFormData._caller === "weekdayUtilization") {
				RestrictionsController.saveChangedWeekdayUtilizationValidity(this.view.validityFormData,
					this.view.weekdayUtilizationPanel, this.$modal);
			} else if (this.view.validityFormData._caller === "productGroupRestrictions") {
				RestrictionsController.saveChangedProductGroupPlateRestrictionsValidity(this.view.validityFormData,
					this.view.productGroupPlateRestrictionsPanel, this.$modal);
			}
		},
		callController: function (methodName, params) {
			return RestrictionsController[methodName] && RestrictionsController[methodName](...params);
		},
		invertValue: function (object, key) {
			object[key] = !object[key];
		},
		updateCheckedRows: function (panel, value) {
			if (panel.isAddingNewRow) {
				let selectedRows = panel.gridConfiguration.advancedOptions.api.getSelectedRows();
				panel.hasCheckedRows = (selectedRows.length && (selectedRows.length > 1 || !selectedRows[0].__is_new_row));
			} else {
				panel.hasCheckedRows = value;
			}
		},
		updateIsAddingNewRow: function (panel, value) {
			panel.isAddingNewRow = value;
			!value && panel.gridConfiguration.enableSelection();
		},
		removeNewRow: function (panel) {
			let rows = panel.gridConfiguration.getRowData();
			rows[0] && rows[0].__is_new_row && rows.shift();
			panel.gridConfiguration.setRowData(rows);
			panel.gridConfiguration.enableSelection();
			panel.isAddingNewRow = false;
			panel.hasCheckedRows = false;
		},
		exportToExcel: function (view) {
			let name = view.selectedValidity.VIGENCIA + ' ';
			name += view.selectedValidity.DESCRICAO ? view.selectedValidity.DESCRICAO || '' : view.selectedValidity.VIGENCIAFIM || '';
			ExcelBuilder.fromJson(
				Util.getVisibleDataFromGrid(view.gridConfiguration),
				Util.getGridColDefsToColDetails(view.gridConfiguration.columnDefs),
				view.title + ' ' + name,
				Util.getExcelHeaderFromFilter(),
			);
		},
		getValidity: function (caller) {
			if (caller == 'plateGroup') {
				return { table: 'FREQGRPRATMES', grid: this.view.plateGroupPanel, tableSelect: 'VIGFREQGRPRATMES', nameVig: 'NRITFREQGRPRATMES' };
			} 
			
			if (caller == 'plate') {
				return { table: 'FREQPRATMES', grid: this.view.platePanel, tableSelect: 'VIGFREQPRATMES', nameVig: 'NRITFREQPRATMES' };
			} 
			
			if (caller == 'weekdayUtilization') {
				return { table: 'UTILPRATOSERV', grid: this.view.weekdayUtilizationPanel, tableSelect: 'VIGUTILPRATOSERV', nameVig: 'NRUTILPRATOSERV' };
			} 
			
			if (caller == 'productGroupRestrictions') {
				return { table: 'RESTPRODGR', grid: this.view.productGroupPlateRestrictionsPanel, tableSelect: 'VIGRESTPRODGR', nameVig: 'NRRESTPRODGR' };
			}
		},
		saveExport: function (view) {
			this.view.exportVigencia._showLoad = false;
			this.$forceUpdate();
			const objectExport = {};
			this.setObjectExport(objectExport, view.exportData);
			this.view.exportVigencia.showSpan = false;
			
			//console.log(objectExport, this.view.exportVigencia);
			
			RestrictionsController.exportValidityProcedureCaller(objectExport, this.$modal, this.view.exportVigencia);
		},
		setObjectExport: function (objectExport, data) {
			const validity = this.getValidity(this.view.exportVigencia._caller);
			objectExport.table = validity.table;
			objectExport.vigencia = validity.grid.selectedValidity.NRVIGENCIA;

			objectExport.opcao = data.mode;
			objectExport.typeProcedure = this.view.exportVigencia._button;

			objectExport.lista = [];
			if (this.view.exportVigencia._button == 'UNITY') {
				if (data.checkedService) {
					data.services.forEach((service) => { objectExport.lista.push(service.CDLISTA) });
				} else {
					data.selectedService.forEach((service) => { objectExport.lista.push(service.CDLISTA) });
				}
			} else if (this.view.exportVigencia._button == 'VALIDITY') {
				objectExport.validityDest = data.selectedValidity.NRVIGENCIA;
				this.buildListProd(objectExport, validity);
			}
		},
		buildListProd: function (objectExport, validity) {
			const nodes = validity.grid.gridConfiguration.gridControl.getSelectedRows();
			nodes.forEach((row) => objectExport.lista.push(row[validity.nameVig]));
		},
		updRestoreFlexibleRules: function () {
			const RESTORE_FLEX_RULES = t('confirm_restore_flex_rules');
			Util.showConfirmationDialog(this.$modal, {
				onModalClose: function (confirmedGenerateBatch) {
					if (confirmedGenerateBatch) {
						RestrictionsController.updRestoreFlexibleRules();
					}
				}.bind(this)
			}, RESTORE_FLEX_RULES);
		},
	}
};
</script>

<style lang="less" scoped>
.select-container {
	display: grid;
	grid-template-columns: 80% 20%;

	.input-container {
		margin: auto;

		input,
		span {
			vertical-align: middle;
			display: inline-block;
		}
	}
}

.allCheck {
	position: relative;
	cursor: pointer;
	height: 20px;
	width: 20px;
}

.allCheck:before {
	content: "";
	display: block;
	position: absolute;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;
	background-color: white;
	border: 2px solid #dc143d;
	border-radius: 5px;
}

.allCheck:checked:before {
	content: "";
	display: block;
	position: absolute;
	margin: auto;
	width: 20px;
	height: 20px;
	top: 0;
	left: 0;
	background-color: #dc143d;
	border: 2px solid #dc143d;
	border-radius: 5px;
}

.allCheck:checked:after {
	content: "";
	display: block;
	width: 5px;
	height: 10px;
	border: solid white;
	border-width: 0 2px 2px 0;
	-webkit-transform: rotate(45deg);
	transform: rotate(45deg);
	position: absolute;
	top: 4px;
	left: 9px;
}

.button {
	min-width: 100px;
	padding: 6px 15px;
	margin: auto 3px;

	&.ghost {
		background-color: white;
		box-shadow: none;
		color: #dc143d;
		border: 1px solid #dc143d;
		padding: 5px 14px;

		&:hover {
			color: #212146;
			border: 1px solid #212146;
		}
	}
}

.mode-switch {
	margin-top: 10px;
	font-size: .9rem;
	border-radius: 5px;
	width: fit-content;
	color: #DC143D;
	border: 1px solid #DC143D;
	cursor: pointer;
	user-select: none;
	width: 100%;
	display: flex;

	.mode-switch-option {
		flex: 1;
		text-align: center;
		border-radius: 5px;
		padding: 7px;
		transition: .3s background-color;

		&:hover {
			background-color: #fcdee4;
		}

		&.active {
			background-color: #DC143D;
			color: white;
		}
	}
}

.select-350 {
	.v-select ul {
		width: 350px;
		z-index: 6;
	}
}

.generic-select-wrapper {



	.v-select {
		width: 280px;
		font-size: .8rem;

		&.vs--open {
			.vs__selected-options {
				overflow: hidden;
			}
		}

		.vs__selected-options {
			min-height: 24px;
			min-width: 0;

			input {
				position: absolute;
				height: 100%;
				width: 100%;
			}

			.vs__selected {
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}


.frequency-header {
	display: flex;
	align-items: center;
}


.restrinctions-grid-button {
	font-size: 0.9rem;
	padding: 6px 13px;
	margin: 5px 0px 5px 5px;
}

.gray-button {
	.restrinctions-grid-button;
	box-shadow: none;
	background-color: #dedede;
	color: #383838;

	&:hover {
		background-color: gray;
		color: white;
	}
}

.button-container {
	margin-top: 3px;
}

.button-container-align-left,
.button-container-align-right {
	display: inline-block;
	flex: 1;
}

.button-container {
	display: flex;
	justify-content: space-between;
}

.button-container-align-right {
	text-align: right;
}

.validity-form-root {
	width: calc(100% - 30px);
	margin: 25px;
	margin-bottom: 30px;

	.autocomplete-field {
		.restrinctions-select-autocomplete {

			.vs__selected-options {
				height: 26px;
			}

			.vs__search {
				position: absolute; 
				padding: 1px;
				border: none;
			}
			

		}
	}


	.title {
		margin-bottom: 5px;
		margin-left: 10px;
	}

	.date-fields-container {
		.field {
			width: 44%;
			display: inline-block;
		}
	}

	.export-container {
		display: inline-block;
		margin: 10px;
		text-align: left;
		font-size: .9rem;
		width: calc(100% - 45px);
	}

	.field {
		display: inline-block;
		margin: 10px;
		text-align: left;
		font-size: .9rem;
		width: calc(100% - 45px);

		&.text-field {
			input {
				padding: 6px 0px 7px 8px;
			}
		}

		input {
			padding: 5px;
			border: 1px solid #BDBDBD;
			box-sizing: border-box;
			border-radius: 4px;
			width: 100%;

			&.input-label {
				border: none;
				border-bottom: 1px solid #BDBDBD;
				border-radius: 0;
			}
		}

	}

	.save-validity-button {
		.restrinctions-grid-button;
		margin-left: 10px;
	}

	&.dialog-box {
		width: auto;
		margin: 0 auto;
		padding: 5px;

		.title {
			text-align: center;
			margin-left: 0;
			margin-top: 10px;
			font-weight: normal;
			font-size: 1rem;
		}

		.service-list {
			list-style: none;
		}

		.dialog-button-container {
			margin-top: 10px;
			display: flex;
			justify-content: center;

			.confirmation-dialog-button {
				.restrinctions-grid-button;
				padding: 9px 30px;
				margin: 5px;
			}
		}
	}

}

#restrictions-container {
	#header-component {
		position: fixed;
		z-index: 7;
		width: calc(100% - 100px);
	}

	#panel-container {
		margin-top: 55px;
	}

	.low-height-grid {
		height: 200px;

		max-height: fit-content;
	}

	#collapsible-panel.collapsible-panel-fullscren {
		position: fixed;
		top: 48px;
		left: 100px;
		z-index: 2;
		background-color: white;
		height: calc(100vh - 69px);
		width: calc(100vw - 125px);
		padding: 20px 15px;
		border-radius: 0;
		padding-top: 0px;
		margin: 0;

		#panel-header {

			.up-arrow,
			.down-arrow {
				display: none;
			}
		}

		.button-container {
			margin-top: 0;
		}

		#panel-content {
			.ag-grid-instance {
				height: calc(100vh - 170px);
			}
		}
	}
}

.v--modal-overlay {
	z-index: 10;
}

.v--modal-box {
	overflow: inherit !important;
	padding: 30px 0;
}

</style>
